import type { PopupData } from 'webapp-types';

import PopupInnerContextComponent from 'webapp/components/popup/inner/context';
import ReportsEditorSlideTypeComponent from 'webapp/components/reports/editor/slide-type';

export default class ReportsPopupSlideTypeComponent extends PopupInnerContextComponent<PopupData.Report.SlideType> {
	<template>
		<ReportsEditorSlideTypeComponent
			@addNewSlideLayoutsDisabled={{this.popupData.addNewSlideLayoutsDisabled}}
			@onSelect={{this.popupData.onSelect}}
			@onClose={{this.close}}
		/>
	</template>
}
